import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {Breadcrumb} from 'antd'

const BBreadcrumb = ({product, categories}) => {
  const [route, setRoute] = useState([])

  useEffect(() => {
    if (product) {
      const tmp = []
      tmp.push({to: '/category/' + categories['category_parent'].alias, title: categories['category_parent'].title})
      tmp.push({to: '/category/' + categories['category_child'].alias, title: categories['category_child'].title})
      tmp.push({to: false, title: product.name})
      setRoute(tmp)
    }
  }, [categories, product])

  return (
    <Breadcrumb>
      <Breadcrumb.Item>
        <Link to='/'>Home</Link>
      </Breadcrumb.Item>
      {route.map(e => (
        <Breadcrumb.Item key={e.title}>
          {e.to ? <Link to={e.to}>{e.title}</Link> : e.title}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  )
}

export default BBreadcrumb
